import React, { useContext, useEffect, useState } from "react";
import InputRegister from "../../../../blocks/ui/InputRegister";
import { summaryDetails } from "../../../../services/Candidate/Profile/summaryDetails";
import { validateSingleField } from '../../../../../utils/validator';
import { Layout } from "./Layout";
import { DContext } from "../../../../../context/Datacontext";
import { useNavigate } from "react-router-dom";

export const SummeryDetails = ({ candidate, fetchCandidateData }) => {
  const { BeURL, currentUser, showAlert } = useContext(DContext);
  const navigate = useNavigate();

  const [profileSummary, setProfileSummary] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCandidateData()
  }, [])

  const [address, setAddress] = useState({
    present: {
      city: "",
      addressLine1: "",
      addressLine2: "",
      zipCode: "",
      state: "",
      country: "",
    },
    permanent: {
      city: "",
      addressLine1: "",
      addressLine2: "",
      zipCode: "",
      state: "",
      country: "",
    },
    sameAsPresent: false,
  });

  const [errors, setErrors] = useState({ present: {}, permanent: {}, profileSummary: "" });

  const mandatory = {
    city: true,
    // addressLine1: true,
    // zipCode: true,
    // state: true,
    // country: true,
  };

  useEffect(() => {
    if (candidate) {
      setAddress({
        present: {
          city: candidate.presentAddress?.city || "",
          addressLine1: candidate.presentAddress?.addressLine1 || "",
          addressLine2: candidate.presentAddress?.addressLine2 || "",
          zipCode: candidate.presentAddress?.zipCode || "",
          state: candidate.presentAddress?.state || "",
          country: candidate.presentAddress?.country || "",
        },
        permanent: {
          city: candidate.permanentAddress?.city || "",
          addressLine1: candidate.permanentAddress?.addressLine1 || "",
          addressLine2: candidate.permanentAddress?.addressLine2 || "",
          zipCode: candidate.permanentAddress?.zipCode || "",
          state: candidate.permanentAddress?.state || "",
          country: candidate.permanentAddress?.country || "",
        },
        sameAsPresent: !!candidate.sameasPresentAddress,
      });
      setProfileSummary(candidate.profileSummary || "");
    }
  }, [candidate]);

  // Validate single field on change
  const handleAddressChange = (type, field, value) => {
    // ensure value is string
    const safeValue = value ?? "";

    setAddress((prev) => {
      const updated = { ...prev };
      if (type === "present") {
        updated.present = { ...prev.present, [field]: safeValue };
        if (prev.sameAsPresent) {
          // keep permanent in sync
          updated.permanent = { ...updated.present };
        }
      } else {
        updated.permanent = { ...prev.permanent, [field]: safeValue };
      }
      return updated;
    });

    // immediate per-field validation
    let fieldError
    if (type === 'present') {
      const fieldMandatory = !!mandatory[field];
      fieldError = validateSingleField(field, String(safeValue), fieldMandatory);
    }



    setErrors((prevErrors) => {
      const next = {
        ...prevErrors,
        [type]: {
          ...prevErrors[type],
          [field]: fieldError,
        },
      };

      // if present changed and sameAsPresent is true, clear permanent errors as permanent mirrors present
      if (type === "present" || address.sameAsPresent) {
        next.permanent = {}; // clear permanent errors
      }

      return next;
    });
  };

  const handleProfileSummaryChange = (value) => {
    setProfileSummary(value);

    let summaryError = "";
    const trimmed = value?.trim() ?? "";
    const words = trimmed === "" ? 0 : trimmed.split(/\s+/).length;

    if (words > 300) {
      summaryError = "Profile Summary cannot exceed 300 words.";
    }

    setErrors((prev) => ({
      ...prev,
      profileSummary: summaryError
    }));
  };


  const handleSubmit = () => {
    let hasError = false;

    // Validate Profile Summary
    let summaryError = "";
    const trimmedSummary = profileSummary?.trim() ?? "";
    const summaryWords = trimmedSummary === "" ? 0 : trimmedSummary.split(/\s+/).length;
    // if (!trimmedSummary) {
    //   summaryError = "Profile Summary is required.";
    //   hasError = true;
    // } else
    if (summaryWords > 300) {
      summaryError = "Profile Summary cannot exceed 300 words.";
      hasError = true;
    }

    // Validate Present Address (only mandatory fields)
    const presentErrors = {};
    for (const field of Object.keys(address.present)) {
      if (mandatory[field]) {
        const val = String(address.present[field] ?? "");
        const err = validateSingleField(field, val, true);
        if (err) {
          presentErrors[field] = err;
          hasError = true;
        }
      }
    }

    // Validate Permanent Address (if not same as present)
    // const permanentErrors = {};
    // if (!address.sameAsPresent) {
    //   for (const field of Object.keys(address.permanent)) {
    //     if (mandatory[field]) {
    //       const val = String(address.permanent[field] ?? "");
    //       // const err = validateSingleField(field, val, true);
    //       // if (err) {
    //       //   permanentErrors[field] = err;
    //       //   hasError = true;
    //       // }
    //     }
    //   }
    // }

    // set errors so UI shows them
    setErrors({
      present: presentErrors,
      // permanent: permanentErrors,
      profileSummary: summaryError,
    });

    if (hasError) {
      // stop submit
      return;
    }

    // All valid — call API
    summaryDetails({ BeURL, profileSummary: trimmedSummary, address, candidateId: candidate._id, navigate, setLoading, showAlert });
  };

  const inputFields = [

    { label: "Address Line 1", name: "addressLine1", mandatory: false },
    { label: "Address Line 2", name: "addressLine2", mandatory: false },
    { label: "City", name: "city", mandatory: true },
    { label: "State", name: "state", mandatory: false },
    { label: "Country", name: "country", mandatory: false },
    { label: "Zip Code", name: "zipCode", mandatory: false },

  ];

  return (
    <Layout candidate={candidate}>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-4 md:py-8 lg:mb-0 mb-14">
        {/* Profile summary */}
        <div className=" w-full">
          <label className="block font-medium mb-1 text-gray-600">
            Profile Summary (Up to 300 Words)
          </label>
          <textarea
            value={profileSummary}
            onChange={(e) => handleProfileSummaryChange(e.target.value)}
            placeholder="Write your profile summary..."
            className={`w-full h-32 shadow rounded-lg p-3 focus:outline-none resize-y ${errors.profileSummary ? "border-red-500" : "focus:ring-2 focus:ring-blue-500"}`}
          />
          {errors.profileSummary && (
            <p className="text-red-500 text-sm mt-1">{errors.profileSummary}</p>
          )}

          {/* Present Address */}
          <div className="mt-4 w-full">
            <h3 className="font-semibold text-base mb-4 text-gray-600">
              Present Address<sup className="text-red-500">*</sup>
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 md:gap-3 w-full">
              {inputFields.map((field, i) => (
                <InputRegister
                  key={i}
                  mandatory={field.mandatory}
                  label={field.label}
                  name={field.name}
                  value={address.present[field.name]}
                  onChange={(e) => handleAddressChange("present", field.name, e.target.value)}
                  className="w-full"
                  placeholder={`${field.label}`}
                  error={errors.present?.[field.name]}
                />
              ))}
            </div>
          </div>

          {/* Permanent Address */}
          <div className="mt-4 md:mt-8">
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-semibold text-base text-gray-600">
                Permanent Address
              </h3>
              <label className="flex items-center gap-2 text-sm cursor-pointer">
                <input
                  type="checkbox"
                  checked={address.sameAsPresent}
                  onChange={(e) =>
                    setAddress((prev) => {
                      const checked = e.target.checked;
                      const newAddr = {
                        ...prev,
                        sameAsPresent: checked,
                        permanent: checked ? { ...prev.present } : { ...prev.permanent },
                      };
                      // if copying from present, clear permanent errors
                      if (checked) {
                        setErrors((prevErrors) => ({ ...prevErrors, permanent: {} }));
                      }
                      return newAddr;
                    })
                  }
                />
                Same as Present Address
              </label>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 md:gap-3">
              {inputFields.map((field, i) => (
                <InputRegister
                  key={i}
                  label={field.label}
                  name={field.name}
                  value={address.permanent[field.name]}
                  onChange={(e) => handleAddressChange("permanent", field.name, e.target.value)}
                  className="w-full"
                  placeholder={`${field.label}`}
                  disabled={address.sameAsPresent}
                  error={errors.permanent?.[field.name]}
                  readOnly={address.sameAsPresent ? true : false}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 w-full my-2">
          {/* Back Button */}
          <button onClick={() => navigate(`/update-account/skills?candidateId=${candidate?._id}`)} className="w-full sm:w-auto border border-primary-500 text-primary-500 px-4 py-2 rounded-xl font-medium  transition text-center">
            Previous
          </button>

          {/* Complete Button */}
          <button
            type="button"
            onClick={handleSubmit}
            disabled={loading}
            className="w-full sm:w-auto bg-[#2C25C4] text-white px-4 py-2 rounded-xl font-semibold shadow-md hover:opacity-90 transition text-center"
          >
            {loading ? "Save..." : "Next"}
          </button>
        </div>
      </section>
    </Layout>
  )
};

